import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _EthnicGroup, _PopulationType } from '../../../../core/services/dataBean/EntityCatalogVdos';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';
import { BasicTable } from '../../../theme/Component/BasicTable';
import { Modal } from '../../../theme/Component/Modal';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const EthnicGroupEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_EthnicGroup)
    const [id, setID] = useState(null);

    const modal = useModal("Tipo de Grupo Étnico", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDEthnicGroup == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getEthnicGroupList(null).then(
            (resp: any) => {
                if (resp) {
                    console.log();

                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'ID', property: 'IDEthnicGroup', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Tipo de Grupo Étnico"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDEthnicGroup); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}